import React from 'react'

const CustomText = (props) => {

  return (
      <div style={props.style}><span style={styles.text}>{props.children}</span></div>
  )
}



export default CustomText

const styles = {
    text: {
        fontFamily: 'Astonpoliz',
        letterSpacing: 0.3,
    }
}